<div class="full-height layout-column">

  <!--Search Box-->
  <div class="padding-10 layout-row">
    <app-bringoz-search-input class="flex"
                              [placeholder]="ngPlaceholder | translate"
                              [query]="queryString"
                              (queryChangeEvent)="submitQuery($event)">

    </app-bringoz-search-input>
  </div>

  <div class="flex"
       *ngFor="let packageItem of options">
    <app-bringoz-radio-button
      [value]="packageItem.id"
      name="standalone-options"
      (onValueChange)="onChange.emit($event)"
      [isSelected]="selectedType === packageItem.id">
      <app-bringoz-package-item [id]="packageItem.id"></app-bringoz-package-item>
    </app-bringoz-radio-button>
  </div>

</div>
